import { render, staticRenderFns } from "./AddRoomModal.vue?vue&type=template&id=2b2ee06c&scoped=true&"
import script from "./AddRoomModal.vue?vue&type=script&lang=ts&"
export * from "./AddRoomModal.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b2ee06c",
  null
  
)

export default component.exports